export function shortenAddress(address, chars = 4) {
    const addr = address.toString();
    return `${addr.substring(0, chars)}...${addr.substring(addr.length - chars)}`;
}
//# sourceMappingURL=displayUtils.js.map